const FTS_PATHS = {
  DASHBOARD: '/',
  NEW_APPLICANT: '/new-applicant',
  NEW_APPLICATION: '/new-application',
  NEW_APPLICATION_WITH_APPLICANT: '/new-application/:applicantId?',
  MY_APPLICATIONS: '/my-applications',
  MY_ACCOUNT: '/my-account',
  UPDATE_ACCOUNT_DETAILS: '/update-account-details',
  APPLICATION: '/application',
  APPLICATION_DETAILS_ROUTE: '/application/:applicationId',
  APPLICATION_DETAILS_WITH_ID: (jobId: string) =>
    `${FTS_PATHS.APPLICATION}/${jobId}`,
  AMEND_APPLICATION_ROUTE: '/application/:applicationId/amend',
  AMEND_APPLICATION_ROUTE_WITH_ID: (applicationId: string) =>
    `/application/${applicationId}/amend`,
  CORRECTION_REQUEST_ROUTE: '/application/:applicationId/request-correction',
  CORRECTION_REQUEST_WITH_ID: (applicationId: string) =>
    `/application/${applicationId}/request-correction`,
};

const AUTH_PATHS = {
  CALLBACK: '/callback',
  LOGOUT_CALLBACK: '/logout-callback',
  SIGNUP: '/signup',
};

const UNAUTH_PATHS = {
  ERROR: '/error',
  NOT_FOUND: '/404',
  WILDCARD: '*',
};

const PATHS = {
  APPLICANT: FTS_PATHS,
  AUTH: AUTH_PATHS,
  UNAUTH: UNAUTH_PATHS,
};

export default PATHS;
